import React, { useContext } from 'react';

import {
  ControllerContainer,
  ControllerSettingsContainer,
} from './DeletePageConfirmation.styled';

import CloseIcon from '../../../assets/icons/close.svg';
import { useEnvelope } from '../../../hooks/useEnvelope';
import { useGenerate } from '../../../hooks/useGenerate';

import { FileContext } from '../../../context/FileContext';


const DeletePageConfirmationModal = ({ isFromGenerateFlow = false }) => {
  const { pageDeleteIndex, setPageDeleteIndex } = useContext(FileContext);

  const { removePageFromEnvelopePDF } = useEnvelope();
  const { removePageFromPdfFileData } = useGenerate();

  const handleDelete = () => {
    if (pageDeleteIndex) {
      if (isFromGenerateFlow) {
        removePageFromPdfFileData(pageDeleteIndex);
      } else {
        removePageFromEnvelopePDF(pageDeleteIndex);
      }
    }
  };

  const handleClose = () => {
    setPageDeleteIndex(false);
  };

  return (
    <ControllerContainer>
      <ControllerSettingsContainer>
        <div className="header">
          Delete this page?
          <img
            className="icon"
            src={CloseIcon}
            alt="close"
            onClick={handleClose}
          />
        </div>

        <div className="content">
          <div>
            If you delete this, all the changes you made will be lost. This
            action can’t be undone.
          </div>
          <div>Are you sure you want to delete?</div>
        </div>
        <div className="footer">
          <button className="danger" onClick={handleDelete}>
            Delete
          </button>
          <button className="outlined" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </ControllerSettingsContainer>
    </ControllerContainer>
  );
};

export default DeletePageConfirmationModal;
